import Axios from "../utils/axiosInterceptor";
import { BILLING_APIS, LIST_DEFAULT_PAGE_SIZE } from "../utils/constants";
import { errorMessage, warningMessage } from "../utils/notificationUtils";

export const GovtBillPostRequest = async (
  healthCareId: number,
  patientId: any,
  caseId: number,
  visitId: number,
  schemeMetaDataId: number,
  patientName: string,
  documentPaths: Array<Document>
): Promise<any> => {
  try {
    const payload = {
      billMapping: {
        patientId,
        caseId,
        visitId,
        hospitalBillUploaded: true, // extra payload added for the new flow
        claimId: null, // extra payload added for the new flow
        patientName,
        schemeMetaDataId,
      },
      documentPaths,
    };
    const resp = await Axios.post<any>(
      `${BILLING_APIS.GovtBillGeneratePostApi}/${healthCareId}`,
      payload
    );

    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot generate govt bill";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GovtBillGetRequest = async (
  healthCareId: number,
  govtBillMappingId: number
): Promise<any> => {
  try {
    // const payload = {
    //   healthCareId,
    //   govtBillMappingId,
    // };

    // const resp = await Axios.get<any>(
    //   `${BILLING_APIS.GovtBillGetApi}/${govtBillMappingId}/health_cares/${healthCareId}`
    // );

    const resp = await Axios.get<any>(
      `${BILLING_APIS.GovtBillAuditGetApi}/${govtBillMappingId}/health_cares/${healthCareId}`
    );

    return resp.data;
  } catch (error: any) {
    // const errorMsg = error?.response?.data?.message || "Cannot get govt bill";
    // errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GovtBillPutRequest = async (
  govtBillHeaderRequest: any,
  govtBillItemsRequests?: any
): Promise<any> => {
  try {
    const payload = {
      billHeaderRequest: govtBillHeaderRequest,
      billItemsRequestList: govtBillItemsRequests,
    };
    // const resp = await Axios.put<any>(
    //   BILLING_APIS.GovtBillUpdatePutApi,
    //   payload
    // );

    const resp = await Axios.put<any>(
      `${BILLING_APIS.GovtBillAuditUpdatePutApi}/${govtBillHeaderRequest?.id}/health_cares/${govtBillHeaderRequest?.healthCareId}`,
      payload
    );

    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update govt bill";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GovtBillApproveRequest = async (
  billMappingId: any,
  healthCareId: any,
  userName: any
): Promise<any> => {
  try {
    const payload = {
      approved_by: userName,
    };
    // const resp = await Axios.put<any>(
    //   BILLING_APIS.GovtBillUpdatePutApi,
    //   payload
    // );

    const resp = await Axios.post<any>(
      `${BILLING_APIS.GovtApproveBill}/${billMappingId}/health_cares/${healthCareId}/approve`,
      payload
    );

    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update govt bill";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const getGovtBillList = async (
  healthCareId: number,
  caseId: number,
  visitId: number,
  filters: any
): Promise<any> => {
  try {
    const payload = {
      // healthCareId,
      caseId,
      visitId,
      searchTerm: "",
      pageNumber: filters?.pageNumber - 1 || 0,
      pageSize: filters?.pageSize || LIST_DEFAULT_PAGE_SIZE,
    };
    const params = {
      pageNumber: filters?.pageNumber - 1 || 0,
      pageSize: filters?.pageSize || LIST_DEFAULT_PAGE_SIZE,
    };
    const resp = await Axios.post(
      `${BILLING_APIS.GetGovtBillList}/${healthCareId}`,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Error in getting bill list";

    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const ChangeWardTypePutRequest = async (
  govtBillMappingId: number,
  healthCareId: number,
  schemeMetaDataId: number,
  wardType: string
): Promise<any> => {
  try {
    // const payload = {
    //   billMappingId: govtBillMappingId,
    //   healthCareId,
    //   schemeMetaDataId,
    //   wardType,
    // };
    const payload = {
      hospital_accreditation: "non-NABH",
      lab_accreditation: "NABL",
      room_category: "GENERAL",
    };
    // const resp = await Axios.put<any>(
    //   BILLING_APIS.ChangeWardTypePutApi,
    //   payload
    // );
    const resp = await Axios.post(
      `${BILLING_APIS.ChangeWardTypePutApiNew}/${govtBillMappingId}`,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update ward type";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const ChangeWardTypePutRequestNew = async (
  govtBillMappingId: number,
  hospital_accreditation: string,
  lab_accreditation: string,
  wardType: string,

): Promise<any> => {
  try {
    // const payload = {
    //   billMappingId: govtBillMappingId,
    //   healthCareId,
    //   schemeMetaDataId,
    //   wardType,
    // };
    const payload = {
      hospital_accreditation: hospital_accreditation,
      lab_accreditation: lab_accreditation,
      room_category: wardType,
    };
    // const resp = await Axios.put<any>(
    //   BILLING_APIS.ChangeWardTypePutApi,
    //   payload
    // );
    const resp = await Axios.post(
      `${BILLING_APIS.ChangeWardTypePutApiNew}/${govtBillMappingId}`,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update ward type";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GetGovtDSBillCompData = async (govtBillMappingId: number) => {
  try {
    // const resp = await Axios.post<any>(BILLING_APIS.GetGovtDSBillCompData, {
    //   billMappingId: govtBillMappingId,
    // });

    const resp = await Axios.get<any>(
      `${BILLING_APIS.DSBillComparison}?bill_id=${govtBillMappingId}`
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot get discharge summary & bill comparison data";
    warningMessage(errorMsg);
  }
};

export const downloadBillSummary = async (govtBillMappingId: number, healthCareId: any, scheme: any, claimId: any) => {
  try {
    const resp = await Axios.get<Blob>(
      `${BILLING_APIS.DownloadBillSummary}/${govtBillMappingId}/health_cares/${healthCareId}/scheme/${scheme}/claim/${claimId}/summary.pdf`,
      {
        responseType: 'blob',
      }
    );

    const url = window.URL.createObjectURL(resp.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `bill_summary_${govtBillMappingId}_${healthCareId}.pdf`; 
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot download bill summary data";
    warningMessage(errorMsg);
  }
};

export const deleteGovtPatientBills = async (
  govtBillIdsToDelete: number[]
): Promise<any> => {
  try {
    const payload = {
      govtBillIdsToDelete,
    };
    const resp = await Axios.put<any>(
      BILLING_APIS.DeleteGovtPatientBills,
      payload
    );
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot delete selected bills";
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const GetGovtMappedCollections = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(BILLING_APIS.GetGovtMappedCollections);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot get categories & sub categories for the bill";
    errorMessage(errorMsg);
  }
};

export const GetAllSchemeCodesData = async ({
  healthCareId,
  schemeId,
  wardType,
  hospitalAccreditation,
  labAccreditation
}: {
  healthCareId: number;
  schemeId: number;
  wardType: string;
  hospitalAccreditation?: any;
  labAccreditation?: any;
}) => {
  try {
    // const resp = await Axios.post<any>(BILLING_APIS.GetAllSchemeCodes, {
    //   healthCareId,
    //   schemeId,
    //   wardType,
    // });

    const resp = await Axios.post<any>(BILLING_APIS.GetAllV2SchemeCodes, {
      healthCareId,
      schemeId,
      wardType,
      hospitalAccreditation,
      labAccreditation
    });

    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get all scheme codes data";
    errorMessage(errorMsg);
  }
};

export const GetAllNewSchemeCodesData = async ({
  healthCareId,
  schemeId,
  wardType,
  hospitalTier,
  hospitalAccreditation,
  labAccreditation
}: {
  healthCareId: number;
  schemeId: number;
  wardType: string;
  hospitalTier: any;
  hospitalAccreditation?: any;
  labAccreditation?: any;
}) => {
  try {
    const resp = await Axios.post<any>(BILLING_APIS.GetAllV2SchemeCodes, {
      healthCareId,
      schemeId: 1,
      hospital_tier: hospitalTier || "tier_2",
      room_category: wardType,
      hospital_accreditation: hospitalAccreditation,
      lab_accreditation: labAccreditation
    });

    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get all scheme codes data";
    errorMessage(errorMsg);
  }
};

export const GetRateList = async ({
  healthCareId,
  schemeId,
  wardType,
  hospitalTier,
  hospitalAccreditation,
  labAccreditation
}: {
  healthCareId: number;
  schemeId: number;
  wardType: string;
  hospitalTier: any;
  hospitalAccreditation?: any;
  labAccreditation?: any;
}) => {
  try {
    const resp = await Axios.post<any>(`${BILLING_APIS.GOVT_BILLING}/cghsBilling/getRateListFileUrl`, {
      healthCareId,
      schemeId: 1,
      hospital_tier: hospitalTier || "tier_2",
      room_category: wardType,
      hospital_accreditation: hospitalAccreditation,
      lab_accreditation: labAccreditation
    });

    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get all rate list data";
    errorMessage(errorMsg);
  }
};

export const GetAllGovtBillItems = async ({
  pageNumber,
  pageSize,
  query,
}: {
  pageNumber: number;
  pageSize: number;
  query?: any;
}) => {
  try {
    const payload = {
      pageNumber: pageNumber - 1,
      pageSize,
      orderBy: "id",
      direction: "desc",
      query: query || "",
    };
    const resp = await Axios.post<any>(BILLING_APIS.AllGovtBillItems, payload);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot get all Govt Bill Items";
    errorMessage(errorMsg);
  }
};

export const UpdateGovtBillItem = async (billItem: any) => {
  try {
    const payload = {
      ...billItem,
    };
    const resp = await Axios.put<any>(BILLING_APIS.UpdateGovtBillItem, payload);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot update Govt Bill Item";
    errorMessage(errorMsg);
  }
};

export const PostDischargeSummaryUpdatedItemsGovt = async (
  billMappingId: number,
  updatedItems: any
): Promise<any> => {
  try {
    const payload = {
      billMappingId,
      updatedItems,
    };
    const resp = await Axios.post<any>(
      BILLING_APIS.GovtDischargeSummaryUpdatedItems,
      payload
    );
    return resp;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || `Cannot update discharge summary items`;
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const auditBillCheck = async (billMappingId: number): Promise<any> => {
  try {
    const resp = await Axios.get<any>(
      `${BILLING_APIS.AUDIT_BLL_CHECK}/${billMappingId}`
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || `Cannot get audit bill items`;
    errorMessage(errorMsg);
    // throw new Error(errorMsg);
  }
};

export const getDSAuditStatus = async (
  caseId: number,
  visitId: number
): Promise<any> => {
  try {
    const payload = {
      caseId,
      visitId,
    };
    const resp = await Axios.post(
      BILLING_APIS.GetDischargeSummaryStatus,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING DS AUDIT STATUS";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getRequiredDocuments = async () => {
  try {
    const resp = await Axios.get(
      `${BILLING_APIS.GOVT_BILLING}/document-requirements/documents/master`
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING DOCUMENT REQUIREMENTS LIST";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const getItemRequiredDocuments = async (itemCode: any, schemeType: any, itemName: any, itemCategory: any) => {
  try {
    const resp = await Axios.get(
      `${BILLING_APIS.GOVT_BILLING}/document-requirements/bill-items/${itemCode}/document-requirements?scheme_type=${schemeType}&item_name=${itemName}&item_category=${itemCategory}`
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING DOCUMENT REQUIREMENTS LIST";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const postItemRequiredDocuments = async (payload: any) => {
  try {
    const resp = await Axios.post(
      `${BILLING_APIS.GOVT_BILLING}/document-requirements/items/add-document-type`,
      payload
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING DOCUMENT REQUIREMENTS LIST";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const postSupportingItemRequiredDocuments = async (billMappingId: any, itemId: any, payload: any) => {
  try {
    const resp = await Axios.post(
      `${BILLING_APIS.GOVT_BILLING}/document-requirements/bills/${billMappingId}/items/${itemId}/mark-requires-document`,
      payload
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN POST SUPPORTING DOCUMENT";
      errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const getAllSupportingDocs = async (billMappingId: any) => {
  try {
    const resp = await Axios.get(
      `${BILLING_APIS.GOVT_BILLING}/document-requirements/bills/${billMappingId}/required-documents`
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING DOCUMENT REQUIRED LIST";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const getRecommendations = async (billMappingId: any) => {
  try {
    const resp = await Axios.get(
      `${BILLING_APIS.GOVT_BILLING}/doctor-feedback/bill/${billMappingId}/recommendations`
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING RECOMMENDATIONS";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const postRecommendations = async (payload: any) => {
  try {
    const resp = await Axios.post(
      `${BILLING_APIS.GOVT_BILLING}/doctor-feedback/`, payload
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN GETTING RECOMMENDATIONS";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const saveDsCorrections = async (payload: any) => {
  try {
    const resp = await Axios.post(
      `${BILLING_APIS.GOVT_BILLING}/ds-feedback/save-correction`, payload
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN SAVING DS CORRECTIONS";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const approveDsCorrections = async (payload: any) => {
  try {
    const resp = await Axios.post(
      `${BILLING_APIS.GOVT_BILLING}/ds-feedback/approve-extraction`, payload
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN APPROVING DS";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}

export const triggerBillAudit = async (data: any) => {
  try {
    const resp = await Axios.post(
      `${BILLING_APIS.TRIGGER_BILLING}`, data
    );
    return resp?.data;
  }
  catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "ERROR IN TRIGGERING BILL AUDIT";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
}


